import { Message } from '../models/message.model';
import { copyToClipboard } from './utils';

/**
 * Get status color for bot connection indicator
 */
export function getConnectionStatusColor(isConnected: boolean, isActive?: boolean): string {
  if (!isConnected) {
    return 'bg-red-400';
  }
  return isActive !== false ? 'bg-green-400' : 'bg-gray-400';
}

/**
 * Get status color based on bot status string
 */
export function getBotStatusColor(status?: string): string {
  if (!status) return 'bg-gray-400';

  switch (status.toLowerCase()) {
    case 'online':
      return 'bg-green-400';
    case 'offline':
      return 'bg-gray-400';
    case 'busy':
      return 'bg-red-400';
    default:
      return 'bg-gray-400';
  }
}

/**
 * Generate gradient style for bot avatar
 */
export function getBotGradientStyle(gradientColors?: {
  start: string;
  middle: string;
  end: string;
}): any {
  if (!gradientColors) {
    // Default gradient
    return {
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      'background-size': '200% 200%',
      animation: 'gradientPulse 4s ease infinite',
    };
  }

  return {
    background: `linear-gradient(135deg, 
      ${gradientColors.start} 0%, 
      ${gradientColors.middle} 50%, 
      ${gradientColors.end} 100%
    )`,
    'background-size': '200% 200%',
    animation: 'gradientPulse 4s ease infinite',
  };
}

/**
 * Copy session ID to clipboard
 */
export async function copySessionIdToClipboard(sessionId: string | undefined, showMessage: (msg: string) => void): Promise<void> {
  if (!sessionId) {
    showMessage('No hay session ID disponible');
    return;
  }

  const success = await copyToClipboard(sessionId);
  if (success) {
    showMessage('Session ID copiado al portapapeles');
  } else {
    showMessage('Error al copiar Session ID');
  }
}

/**
 * Format chat history for clipboard
 */
export function formatChatForClipboard(messages: Message[]): string {
  if (!messages || messages.length === 0) {
    return 'No hay mensajes para copiar';
  }

  return messages
    .map((msg) => {
      const sender = msg.isUser ? 'Usuario' : 'Bot';
      const timestamp = msg.timestamp
        ? new Date(msg.timestamp).toLocaleString('es-CL')
        : '';
      return `[${timestamp}] ${sender}: ${msg.content}`;
    })
    .join('\n\n');
}

/**
 * Copy chat history to clipboard
 */
export async function copyChatHistoryToClipboard(
  messages: Message[],
  showMessage: (msg: string) => void
): Promise<void> {
  const formattedChat = formatChatForClipboard(messages);
  const success = await copyToClipboard(formattedChat);

  if (success) {
    showMessage(`Chat copiado al portapapeles (${messages.length} mensajes)`);
  } else {
    showMessage('Error al copiar el chat');
  }
}
